let builder = require('../builder-componenets');
let fieldManager = require('./fields');

module.exports = {
    tableBuilderDragnDrop() {
        $(".dragable").draggable({
            revert: "invalid",
            containment: "document",
            helper: "clone",
            cursor: "move"
        });

        $(".drag-field").draggable({
            revert: "invalid",
            containment: "document",
            helper: "clone",
            cursor: "move",
            cancel: ".orderField",
        });
        this.attachDroppable('.sectionBody:not(.relatedSectionBody):not(.attachmentsBody)');
    },

    attachDroppable(elm) {

        var _this = this;

        let propsContent = $('.propertiesContent');

        return $(elm).droppable({
            accept: ".dragable, .section-field-container",
            drop: function (event, ui) {
                let $parent = $(this).parents('.table-section'),
                    parent_section_id = $parent.attr('data-section-id'),
                    parent_section_name = $parent.attr('data-section-name').trim(),
                    $field = $(ui.draggable),
                    section_id = $field.attr('data-section-id'),
                    curr_table = $('.builder-main').data('id');

                $('.tab-control').removeClass('active');
                $('.propertiesTabHeader').addClass('active');

                if (section_id && parent_section_id !== section_id) {
                    if (parent_section_name !== 'hidden_fields') {
                        $(this).append(ui.draggable);
                    } else {
                        $(this).prepend(ui.draggable);
                    }
                    $(ui.draggable).click();
                } else {
                    let fieldType = $(ui.draggable).data('name');
                    let itemOrder = $(this).find('.section-field-container').length + 1;

                    if (fieldType === 'link_to_another_table') {
                        let propsContent = $('.propertiesContent');
                        let content = '';

                        $('body').find('.fieldsSection').removeClass('activeSection');

                        let order = $('body').find('.fieldsSection').length + 1;

                        let tbOptions = '';

                        $.get("/get-all-tables", data => {
                            for (let table of data) {
                                tbOptions += `<option value="${table.id}" >${table.label}</option>`;
                            }

                            content += `<div class="row table-section mb-4 fieldsSection activeSection related-section"
                                            data-section-order="${order}"
                                            data-section-label=""
                                            data-section-name=""
                                            data-related-section="1"
                                            data-allow-edit="0"
                                            data-disable-related-hyperlink="0"
                                            data-enable-counter="0"
                                            data-allow-scroll="0"
                                            data-full-text="0"
                                            data-no-of-records="10"
                                            data-section-id="">
                                            <div class="col-sm-7 mx-auto card" >
                                                <div class="card-header">
                                                    <a
                                                        href="#"
                                                        class="sectionTitle">
                                                        <h5 class="card-title">Untitled</h5>
                                                    </a>
                                                    <a href="#" class="del-controller deleteSection">
                                                        <i class="fas fa-trash"></i>
                                                    </a>
                                                </div>
                                                <div class="card-body sectionBody relatedSectionBody related-section-body"></div>
                                            </div>
                                        </div>`;

                            $(content).insertAfter($parent);
                            propsContent.html(builder.newRelatedSectionProperties(tbOptions));
                            fieldManager.manageFieldsProps();
                            content = '';
                            $('body').find('.propsControl').removeClass('activeField');

                            $('.fieldsSection').each(function (i, item) {
                                $(item).data('section-order', i + 1).attr('data-section-order', i + 1);
                            });
                        });
                    } else {

                        $(this).parents('.fieldsSection').addClass('activeSection');
                        $(this).find('.propsControl').removeClass('activeField');

                        if (fieldType === 'relationship') {
                            let tablesOpt = '';
                            $.get("/get-all-tables", data => {
                                for (let table of data) {
                                    tablesOpt += `<option value="${table.id}">${table.label}</option>`;
                                }
                                let propsData = builder.fieldSettings(tablesOpt, fieldType);
                                propsContent.html(propsData);
                                $(this).append(builder.getFieldData(fieldType, itemOrder));
                            });

                        } else if (fieldType === 'alert') {
                            let datetime_fields = '';
                            $.get(`/tablebuilder/${curr_table}/datetime`, data => {
                                for (let field of data) {
                                    datetime_fields += `<option value="${field.id}">${field.label}</option>`;
                                }
                                let propsData = builder.fieldSettings(datetime_fields, fieldType);
                                propsContent.html(propsData);
                                $(this).append(builder.getFieldData(fieldType, itemOrder));
                                $('.selectpicker').selectpicker('refresh');
                            });
                        } else if (fieldType === 'button') {
                            let automationOpts = '<option value="">Select automation</option>';
                            $.get(`/get-all-automations/${curr_table}`, data => {
                                for (let automation of data) {
                                    automationOpts += `<option value="${automation.id}">${automation.description ? automation.description : `Automation ID # ${automation.id}`}</option>`;
                                }
                                let propsData = builder.fieldSettings(automationOpts, fieldType);
                                propsContent.html(propsData);
                                $(this).append(builder.getFieldData(fieldType, itemOrder));

                                $('.btn-text-color, .btn-color').colorpicker({
                                    format: "hex",
                                    autoInputFallback: false,
                                    useAlpha: true
                                });
                                let $input = $('.btn-text-color').find('input');
                                $($input).val('#FFFFFF').trigger('change');
                                $input = $('.btn-color').find('input');
                                $($input).val('#626A6F').trigger('change');
                            });
                        } else {
                            let propsData = builder.fieldSettings(null, fieldType);
                            propsContent.html(propsData);

                            if (parent_section_name !== 'hidden_fields') {
                                $(this).append(builder.getFieldData(fieldType, itemOrder));
                            } else {
                                $(this).prepend(builder.getFieldData(fieldType, itemOrder));
                            }
                            $('.propsField').keyup();

                            if (fieldType === 'select') {
                                $('.change_option').colorpicker({
                                    format: "hex",
                                    autoInputFallback: false,
                                    useAlpha: true
                                });
                                let $input = $('.change_option').find('input');
                                $($input).val('#FFFFFF').trigger('change');
                            } else if (fieldType === 'formula') {
                                _this.initFormulaBuilder();
                            }

                            $(ui.draggable).click();
                        }

                        $(this).removeClass('emptySectionBody')
                        fieldManager.manageFieldsProps();
                    }
                }
            }
        });
    },

    registerFormulaBuilderEvents() {
        let $body = $('body'),
            _this = this;

        $body.on('click', '#add-formula-function', function (e) {
            if ($('#formula-function').val().length) {
                let value = $('#formula-function').val()[0];
                _this.insertContentAtPointer(value);
            }
        });

        $body.on('click', '#edit-formula', function (e) {
            let formula = $('.propsField[data-field="formula"]').val();
            _this.initFormulaBuilder(formula);
        });

        $body.on('click', '#check-formula-syntax', function (e) {
            let formula = $('#formatted-formula').val(),
                $error = $('.formatting-error'),
                $success = $('.success-message');


            $error.text('');
            $success.text('');
            if (formula.length) {
                _this.checkFormulaSyntax(formula, 'check');
            } else {
                $error.text('Formula expression cannot be empty.');
            }
        });

        $body.on('click', '#add-formula-field', function (e) {
            if ($('#formula-field').val().length) {
                let value = $('#formula-field').val()[0];
                value = `\${${value}\}`;
                _this.insertContentAtPointer(value);
            }
        });

        $body.on('click', '#add-formula-operator', function (e) {
            if ($('#formula-operator').val().length) {
                let value = $('#formula-operator').val()[0];
                _this.insertContentAtPointer(value);
            }
        });

        $body.on('click', '#save-formula', function (e) {
            let formula = $('#formatted-formula').val(),
                $error = $('.formatting-error'),
                $success = $('.success-message');

            $error.text('');
            $success.text('');

            _this.checkFormulaSyntax(formula, 'save');
        });

        $body.on('change', '#select-formula-table', function (e) {
            let value = $(this).val(),
                curr_table = $(this).data('table-id');
            console.log(value, curr_table);

            $.ajax({
                type: 'GET',
                url: '/tablebuilder/formula_builder/fields',
                data: {
                    current_table: curr_table,
                    related_table: value
                },
                success: function (res) {
                    $('#formula-field').empty().html(res);
                }
            })
        });
    },

    initFormulaBuilder(formula = '') {
        let $modal = $('#formula-model'),
            $body = $('#formula-body'),
            $title = $('#formula-title'),
            table_id = $('.builder-main').data('id');

        $.ajax({
            type: 'GET',
            url: '/tablebuilder/formula_builder',
            data: {
                table_id
            },
            success: (res) => {
                $body.html(res);
                $modal.modal('show');
                if (formula) {
                    $('#formatted-formula').val(formula);
                }
            }
        })
    },

    insertContentAtPointer(content) {
        let $txt = jQuery("#formatted-formula");
        let caretPos = $txt[0].selectionStart;
        let textAreaTxt = $txt.val();
        let txtToAdd = content;
        $txt.val(textAreaTxt.substring(0, caretPos) + txtToAdd + textAreaTxt.substring(caretPos));
        $txt.focus();
    },

    checkFormulaSyntax(formula, action) {
        let table_id = $('.builder-main').data('id'),
            $error = $('.formatting-error'),
            $success = $('.success-message');

        $.ajax({
            type: 'GET',
            url: "/tablebuilder/parser/validate",
            data: {
                formula,
                table_id
            },
            success: function (res) {
                if (!res) {
                    $($error).text('Invalid syntax');
                } else {
                    $success.text('No errors');
                    if (action === 'save') {
                        $('.propsField[data-field="formula"]').val(formula).trigger('keyup');
                        $('#formula-model').modal('hide');
                    }
                }
            },
            error(res) {
                $($error).text('Invalid syntax');
            }
        })
    }
}